import { Node } from "tiptap";

export default class WrapElement extends Node {
  get name() {
    return "wrap_element";
  }

  get schema() {
    return {
      content: "block*",
      group: "block",

      draggable: false,

      attrs: {
        id: { default: null },
        tag: { default: "div" },
        class: { default: null, },
        style: { default: null },
        userData: { default: [] },
      },
      parseDOM: [
        {
          tag: "div",
          getAttrs: function(dom) {
            let userData = [];
            if (dom.getAttributeNames) {
              let keys = dom.getAttributeNames();
              if (!keys) { keys = [] };
              keys.forEach(key => {
                if (
                  key.lenght > 5 && key.substring(0, 5) === "data-" &&
                  !(key.length > 7 && key.substring(0, 7) === "data-v-")) {
                  userData.push({ key: key, value: dom.getAttribute(key) });
                }
              });
            }
            else {
              for(let ninx = 0, attrs = dom.attributes; ninx < attrs.length; ninx++) {
                let key = attrs[ninx].name;
                if (
                  key.lenght > 5 && key.substring(0, 5) === "data-" &&
                  !(key.length > 7 && key.substring(0, 7) === "data-v-")) {
                  userData.push({ key: key, value: dom.getAttribute(key) });
                }
              }
            }
            return {
              id: dom.getAttribute("id"),
              tag: dom.nodeName.toLowerCase(),
              class: dom.getAttribute("class"),
              style: dom.getAttribute("style"),
              userData: userData,
            };
          }
        },
      ],
      // toDOM: node => ["div", { class: node.attrs.class }, 0 ],
      toDOM: function(node) {
        let attrs = {
          id: node.attrs.id,
          class: node.attrs.class,
          style: node.attrs.style,
        };
        if (node.attrs.userData) {
          node.attrs.userData.forEach(item => {
            attrs[item.key] = item.value;
          });
        }
        return [
          node.attrs.tag, 
          attrs,
          0
        ];
      }
    };
  }
}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/extensions/WrapElement.js